import React from "react";
import MySkeleton from "components/ui/feedback/Skeleton";
import { useStatsFetch } from "./useStatsApi";
import { StatCard, SectionCard, RefreshButton, ErrorMessage, formatNumber } from "./StatComponents";

const OverviewSection = () => {
  const { data, isLoading, error, load } = useStatsFetch("/admin/statistics/overview");

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "15px" }}>
        <RefreshButton onClick={() => load()} isLoading={isLoading} />
      </div>

      <ErrorMessage message={error} />

      {isLoading && !data ? (
        <MySkeleton lineCount={8} />
      ) : data ? (
        <>
          <SectionCard title="Bugünkü Aktivite">
            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
              <StatCard
                label="Bugün Görülen Cihaz"
                value={data.activeDevices?.today}
                sub="Mobile kaydı bugün güncellenenler"
                color="#2e7d32"
              />
              <StatCard
                label="Dün Görülen Cihaz"
                value={data.activeDevices?.yesterday}
                sub="Mobile kaydı dün güncellenenler"
                color="#66bb6a"
              />
              <StatCard label="Kayıtlı Telefon (UserPhone)" value={data.userPhones} color="#9e9e9e" />
              <StatCard label="Mobil Hesap (Mobile)" value={data.mobiles} color="#9e9e9e" />
            </div>
          </SectionCard>

          <SectionCard title="Şirketler ve Okullar">
            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
              <StatCard
                label="Şirket"
                value={data.companies?.total}
                sub={`${formatNumber(data.companies?.active)} aktif / ${formatNumber(data.companies?.demo)} demo`}
                color="#1976d2"
              />
              <StatCard label="Okul" value={data.schools} color="#0288d1" />
              <StatCard label="Panel Kullanıcısı (Client)" value={data.clients} color="#00838f" />
            </div>
          </SectionCard>

          <SectionCard title="Kişiler">
            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
              <StatCard label="Toplam Kişi (User)" value={data.users?.total} color="#7b1fa2" />
              <StatCard label="Veli" value={data.users?.parents} color="#8e24aa" />
              <StatCard label="Sürücü" value={data.users?.drivers} color="#ab47bc" />
              <StatCard label="Personel" value={data.users?.personel} color="#ce93d8" />
              <StatCard label="Öğrenci" value={data.students} color="#5e35b1" />
              <StatCard label="İlişki (Veli-Öğrenci)" value={data.relations} color="#9575cd" />
            </div>
          </SectionCard>

          <SectionCard title="Operasyon">
            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
              <StatCard label="Öğrenci Servisi" value={data.vehicleRoutes} color="#ef6c00" />
              <StatCard label="Personel Servisi" value={data.personelServices} color="#f57c00" />
              <StatCard label="Araç" value={data.vehicles} color="#ff9800" />
              <StatCard label="Sözleşme" value={data.contracts} color="#6d4c41" />
              <StatCard label="Tahsilat" value={data.receipts} color="#8d6e63" />
            </div>
          </SectionCard>
        </>
      ) : null}
    </div>
  );
};

export default OverviewSection;
